import React from 'react';
import { Inbox } from 'lucide-react';

/**
 * Estado vacío reutilizable para tablas, listas y rejillas.
 *
 *   <EmptyState
 *     title="Sin contratos en este filtro"
 *     description="Prueba a quitar el filtro de zona o ampliar el rango de fechas."
 *     icon={FileStack}
 *     action={<Button onClick={...}>Limpiar filtros</Button>}
 *   />
 *
 * Variante para usar dentro de <td colSpan={N}>:
 *   <EmptyState compact title="..." description="..." />
 */
export const EmptyState = ({
  icon: Icon = Inbox,
  title = 'Nada por aquí',
  description,
  action,
  compact = false,
  className = '',
  testid = 'empty-state',
}) => (
  <div
    className={`flex flex-col items-center justify-center text-center ${compact ? 'py-8 px-4' : 'py-14 px-6'} ${className}`}
    data-testid={testid}
  >
    <div className={`rounded-full bg-ink-50 ${compact ? 'p-2.5' : 'p-3.5'} mb-3 text-ink-400`}>
      <Icon className={compact ? 'w-5 h-5' : 'w-7 h-7'} />
    </div>
    <p className={`font-semibold text-ink-700 ${compact ? 'text-sm' : 'text-base'}`}>{title}</p>
    {description && (
      <p className={`text-ink-500 mt-1 max-w-md ${compact ? 'text-xs' : 'text-sm'}`}>{description}</p>
    )}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export default EmptyState;
